import Box from '@mui/material/Box';
import React from 'react';

const Image = ({ name, cdn, src, sx, ...rest }) => {
    const getSrc = () => {
        if (name) return `/images/${name}`;

        if (cdn) return process.env.REACT_APP_CDN_SERVER + '/images/' + cdn;

        return src;
    };

    return (
        <>
            <Box
                component='img'
                src={getSrc()}
                alt='image'
                sx={{ maxWidth: '100%', ...sx }}
                {...rest}
            />
        </>
    );
};

export default Image;